import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import { translateSubElementString } from "../../../../../../utils";
import * as React from "react";
import PreviewScopeSection from "./PreviewScopeSection";
import TotalsSection from "./TotalsSection";


function PreviewConsumptionBased({ data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });
  const { t: globalTranslation } = useTranslation("translation");

  return (
    <Box>

      {/* Scope 1: Direct Emissions Section */}
      <PreviewScopeSection
        title={t("scope1Title")}
        data={data?.directEmissions}
        totalEntity={{
          title: translateSubElementString("reportsPage.directTotal"),
          subTitle: ` (${globalTranslation(`measures.tonnes`)})`,
          value: data?.directTotalCo2Emissions
        }}
      />

      {/* Scope 2: Indirect Emissions Section */}
      <PreviewScopeSection
        title={t("scope2Title")}
        data={data?.indirectEmissions}
      />

      <TotalsSection data={data} />
    </Box>
  );
}

export default PreviewConsumptionBased;